import { BigNumber } from 'ethers';
import { formatPercentages, formatUSD } from '../../../helpers';
import { useMemo } from 'react';
import { formatEther, parseEther, parseUnits } from 'ethers/lib/utils';
import useChartState from '../../../context/chart/useChartState';
import useTradeState from '../../../context/trade/useTradeState';
import useUserFee from '../../../hooks/web3/useUserFee';
import useTokenStats from '../../../hooks/web3/useTokenStats';

const ExchangeSwapPreview = () => {
    const { selectedTradePair } = useChartState();
    const { isShort, leverage, collateral, limitPrice } = useTradeState();
    const tokenStats = useTokenStats();
    const { userFee } = useUserFee();

    const entryPrice = limitPrice
        ? limitPrice
        : selectedTradePair?.chartSymbol
        ? tokenStats?.[selectedTradePair.chartSymbol]?.price
        : undefined;

    const finalCollateral = useMemo(
        () =>
            collateral && leverage && userFee
                ? parseEther(collateral)
                      .mul(parseEther('1'))
                      .div(
                          parseEther('1').add(
                              parseEther(leverage).mul(userFee).div(100_00)
                          )
                      )
                : parseEther('0'),
        [collateral, leverage, userFee]
    );

    const size = useMemo(
        () =>
            finalCollateral && leverage
                ? finalCollateral.mul(parseEther(leverage)).div(parseEther('1'))
                : BigNumber.from(0),
        [finalCollateral, leverage]
    );

    const liqPrice = useMemo(
        () =>
            leverage && entryPrice
                ? parseEther(entryPrice)
                      .mul(
                          parseEther('1')[isShort ? 'add' : 'sub'](
                              parseEther('1')
                                  .mul(parseUnits('1', 2))
                                  .div(parseUnits(leverage, 2))
                          )
                      )
                      .div(parseEther('1'))
                : BigNumber.from(0),
        [leverage, entryPrice, isShort]
    );

    const fees = useMemo(
        () => (userFee ? size.mul(userFee).div(100_00) : parseEther('0')),
        [size, userFee]
    );

    return (
        <div className='swap-detail'>
            <div className='size'>
                <span>Size</span>
                <span>
                    {size.isZero()
                        ? '-'
                        : formatUSD(formatEther(size || '0'), { minDecimals: 2 })}
                </span>
            </div>
            <hr />
            <div className='leverage'>
                <span>Leverage</span>
                <span>{formatPercentages(leverage || 0)}x</span>
            </div>
            <div className='entry-price'>
                <span>Entry Price</span>
                <span>
                    {!entryPrice
                        ? '-'
                        : formatUSD(entryPrice || 0, {
                              minDecimals: 2,
                              maxDecimals: selectedTradePair?.decimalFormatting,
                          })}
                </span>
            </div>
            {/* <EntryPrice /> */}
            <div className='liquidity-price'>
                <span>Liq. Price</span>
                <span>
                    {liqPrice.isZero()
                        ? '-'
                        : formatUSD(formatEther(liqPrice || '0'), {
                              minDecimals: 2,
                              maxDecimals: selectedTradePair?.decimalFormatting,
                          })}
                </span>
            </div>
            <div className='fees'>
                <span>Fees</span>
                <span>
                    {fees.isZero()
                        ? '-'
                        : formatUSD(formatEther(fees || '0') || 0, { minDecimals: 2 })}
                </span>
            </div>
        </div>
    );
};

export default ExchangeSwapPreview;
